(function() {
  'use strict';
  
  function initProductCarousel() {
    const productCards = document.querySelectorAll('.grid__item');
    
    productCards.forEach(card => {
      const images = card.querySelectorAll('img[src*="/products/"]');
      if (images.length < 2) return;
      
      // Coletar todas as URLs únicas de imagens
      const imageUrls = new Set();
      images.forEach(img => {
        if (img.src) imageUrls.add(img.src);
        if (img.dataset.src) imageUrls.add(img.dataset.src);
      });
      
      const urlArray = Array.from(imageUrls);
      if (urlArray.length < 2) return;
      
      const mainImage = images[0];
      let currentIndex = 0;
      let interval = null;
      
      card.addEventListener('mouseenter', function() {
        interval = setInterval(function() {
          currentIndex = (currentIndex + 1) % urlArray.length;
          mainImage.src = urlArray[currentIndex];
        }, 1800);
      });
      
      card.addEventListener('mouseleave', function() {
        if (interval) {
          clearInterval(interval);
          interval = null;
        }
        currentIndex = 0;
        mainImage.src = urlArray[0];
      });
    });
  }
  
  // Tentar múltiplas formas de inicializar
  if (document.readyState === 'complete') {
    initProductCarousel();
  } else {
    window.addEventListener('load', initProductCarousel);
  }
  
  // Backup: tentar novamente após 1 segundo
  setTimeout(initProductCarousel, 1000);
})();
